import { imageMock } from '@mock/schema/components/shared';
import { Video } from '@shared/components/video/models';
import { getUuid } from '@shared/utils';

type externalVideoId = 1 | 2 | 3;

export const videoMock = (withText = false, externalVideoId?: externalVideoId): Video => ({
  text: withText ? `Des meubles fabriqués en France` : '',
  poster: imageMock,
  url: externalVideoId ? externalVideoUrl(externalVideoId) : `/assets/tmp/video.mp4?r=${getUuid()}`,
});

const externalVideoUrl = (id: externalVideoId): string => {
  switch (id) {
    case 1:
      return `http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4?r=${getUuid()}`;
    case 2:
      return `http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4?r=${getUuid()}`;
    case 3:
      return `http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4?r=${getUuid()}`;
    default:
      return `http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4?r=${getUuid()}`;
  }
};
